// @flow
import * as React from 'react';
import { IconButton, Menu as MuiMenu, MenuItem } from '@mui/material';
import { Gear, GearSix, Password, UserCirclePlus } from '@phosphor-icons/react';
import {
  useResetPasswordMutation,
  useSaveUserProfileMutation,
  useSetClientUserIdMutation
} from '../../../shared';
import { enqueueSnackbar } from 'notistack';
import { useConfirm } from '@coverright/features';
import { theme } from '../../../app/theme';
import { Client } from '../../../shared/api/use-client-subscription';
import { ProfileOption } from '@coverright/data-access/types/enrollment';


export const ClientMenu = ({client}: {client?: Partial<Client>}) => {
  const [reset] = useResetPasswordMutation({
    variables: {clientId: client?.id},
    onCompleted: () => enqueueSnackbar('Reset password email sent', {variant: "success"})
  });
  const [setClientUserId] = useSetClientUserIdMutation({
    onCompleted: data => enqueueSnackbar('Account created', {variant: "success"})
  })
  const [saveProfile] = useSaveUserProfileMutation({
    onCompleted: async data => {
      setClientUserId({variables: { clientId: data.saveUserProfile.clientId, userId: data.saveUserProfile.userId } })
    }
  })

  const confirm = useConfirm(theme);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (callback?: () => void) => {
    setAnchorEl(null);
    callback && callback();
  };

  const resetPassword = () => {
    confirm({
      content: 'Are you sure you want to reset password to this user?',
      okButtonTitle: 'Reset password'
    })
      .then(async val => {
        if (val) {
          await reset();
        }
      })
  }

  const createAccount = () => {
    if (!client?.email) {
      confirm({
        content: 'You have to assign email to this client first',
        okButtonTitle: 'Ok'
      })
    } else {
      saveProfile({
        variables: {
          data: {
            email: client?.email,
            firstName: client?.firstName,
            lastName: client?.lastName,
            phoneNumber: client?.phoneNumber,
            profileId: client?.profileId,
            options: [ProfileOption.RegisterUser],
            quoteId: client?.quoteId,
            medigapQuoteId: client?.medigapQuote?.id,
            pdpQuoteId: client?.pdpQuote?.id,
            gender: client?.gender,
            birthDate: client?.birthDate,
            tobacco: typeof client?.tobacco !== 'undefined' ? client?.tobacco : undefined,
            zip: client?.zip,
            countyName: client?.countyName,
            state: client?.state,
            adviserEmail: client?.adviserEmail,
            enrolled: client?.enrolled,
            adviserName: client?.adviserName
          }
        }
      })
    }
  }

  if (!client) {
    return null;
  }


  return <>
    <MuiMenu
      anchorEl={anchorEl}
      open={open}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      onClose={() => handleClose()}
      sx={{'& .MuiPaper-root': {width: 220} }}
    >
      {client?.cId && <MenuItem onClick={() => (
        navigator.clipboard.writeText(client!.cId!)
          .then(() => enqueueSnackbar('Copied!', {variant: "info"}))
      )} sx={{gap: 1}}>
        Copy cId
      </MenuItem>}
      {client?.userId && <MenuItem onClick={() => handleClose(resetPassword)} sx={{gap: 1}}>
        <Password size={18} color="#1c434f" />
        Reset password
      </MenuItem>}
      {!client?.userId && <MenuItem onClick={() => handleClose(createAccount)} sx={{gap: 1}}>
        <UserCirclePlus size={18} color="#1c434f" />
        Create user account
      </MenuItem>}
    </MuiMenu>
    <IconButton onClick={handleClick} size={'small'}>
      <GearSix />
    </IconButton>
  </>
};
